import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { CreateLocalLink } from '../../utils'
import { NewsAndMore } from '../../components/homeNews'

const PostRelated = ({ links, currentIndex }) => {
	const data = useStaticQuery(SIBLING_QUERY)

	const {
		wpgraphql: {
			posts: { nodes: blogPosts },
			generalSettings: { url: wordpressUrl },
		},
	} = data

	let limit = 0

	const afterSiblings = blogPosts.filter((post, index) => {
		if (index > currentIndex && limit < 3) {
			limit++
			return post
		}
	})

	const beforeSiblings = blogPosts
		.filter((post, index) => {
			if (index < currentIndex && limit < 3) {
				limit++
				return post
			}
		})
		
	const siblings = afterSiblings.concat(beforeSiblings)
	
	const cleanSiblings = siblings.map((post) => {
		post.url = post.uri
		let postObj = {
			type: 'news',
			post: post,
		}

		return postObj
	})

	cleanSiblings.push({
		type: 'link',
		title: 'Lets talk ethics & sustainability.',
		post: {
			uri: '/sustainability',
		},
	})

	const { singleRelatedLinks: relatedPosts } = links
	
	let cleanRelatedPosts = null
	if(relatedPosts != null) {
		cleanRelatedPosts = relatedPosts.map((post, index) => {

			const { singleRelatedType: type, singleRelatedPost: relatedPost } = post

			if (relatedPost && type == 'news')
			{
				relatedPost.link = relatedPost.uri
			}

			const postObj = {
				'title': relatedPost.title,
				'type' : type,
				'post' : relatedPost,
			}

			return postObj
		})
	}

	return cleanRelatedPosts == null ? (
		<NewsAndMore links={cleanSiblings} />
	) : (
		<NewsAndMore links={cleanRelatedPosts} />
	)
}

export default PostRelated

const SIBLING_QUERY = graphql`
	query GETSINBLINGPOSTS {
		wpgraphql {
			generalSettings {
				url
			}
			posts(first: 10000, after: null) {
				nodes {
					title
					id
					link
					uri
					featuredImage {
						node {
							sourceUrl
							altText
							mediaItemUrl
						}
					}
					categories {
						nodes {
							name
							slug
						}
					}
				}
			}
		}
	}
`
